import React, { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";
import {
  postQrCodeByStatus,
} from "../../services/QrCode/postQrCodeByStatus";
import { InputText } from "primereact/inputtext";
import SuccessModal from "../SuccessModal";
import { Button } from "react-bootstrap";
import { IconField } from "primereact/iconfield";
import { errorMessage, successMessage } from "../../utils/alertMessage";
import { mapRFIDTag, searchRFIDTag } from "../../services/RFID/Rfid";

const GarmentRFIDList = () => {
  const location = useLocation();
  const {
    bookingOrderId,
    storeCustomerId,
  } = location.state || {}; // Fallback to prevent undefined errors

  const { brandProfileData, storeData, userProfileData } = getUserData();

  let userRole = userProfileData;
  let storeId = storeData.id;
  let brandId = brandProfileData.id;

  const navigate = useNavigate();
  const [tagInfo, setTagInfo] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [apiResStatus, setApiResStatus] = useState(false);
  const [apiResMessage, setApiResMessage] = useState(false);

  const fetchQrCode = () => {
    const data = {
      status: ["IN_PROCESS"],
    };
    postQrCodeByStatus(storeCustomerId, storeId, bookingOrderId, data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data.map((item) => ({
            ...item,
            checked: false,
          }));
          setTagInfo(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchQrCode();
  }, []);

  // Add this state at the top of your component
  const [rfidInputs, setRfidInputs] = useState({}); // key = garmentId, value = tagId

  const inputRefs = useRef({}); // store refs for each garment input

  const handleRFIDScan = (garmentId, tagId) => {
    // const tagId = rfidInputs[garmentId]?.trim();
    if (!tagId && (tagId.length > 24 || tagId < 24)) {
      errorMessage("Please scan a valid RFID tag");
      return;
    }

    const data = {
      brandIdIn: [brandId],
      storeIdIn: [storeId],
      searchType: "mapped",
      rfIdIn: [tagId],
    };

    searchRFIDTag(data)
      .then((response) => {
        if (!response.data.error) {
          const resData = response.data;
          if (resData.length === 0) {
            const garmentItem = tagInfo.find((item) => item.id === garmentId);
            if (!garmentItem) {
              errorMessage("Garment not found.");
              return;
            }

            // Update local state — map RFID tag to garment
            const updatedList = tagInfo.map((item) =>
              item.id === garmentId ? { ...item, rfid: tagId } : item
            );
            setTagInfo(updatedList);

            successMessage(
              `RFID ${tagId} mapped to ${garmentItem.garmentAlias}`
            );

            // Clear the RFID input (not really needed once input is hidden)
            //  setRfidInputs((prev) => ({ ...prev, [garmentId]: "" }));

            // Focus the next input if available
            const index = tagInfo.findIndex((item) => item.id === garmentId);
            const nextItem = tagInfo[index + 1];
            if (nextItem && inputRefs.current[nextItem.id]) {
              setTimeout(() => {
                inputRefs.current[nextItem.id].focus();
              }, 200); // small delay ensures React re-renders first
            }
          } else {
            errorMessage("RFID tag is already mapped");
          }
          // setApiResponse(resData);
          // setApiResStatus(true);
          // setApiResMessage("RFID Is Mapped");
          // setModalVisible(true);
        } else {
          setApiResStatus(false);
          setApiResMessage(response.data.message || "Error fetching RFID info");
          setModalVisible(true);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
        errorMessage("Something went wrong while fetching RFID info");
      });
  };

  useEffect(() => {
    // Focus first unmapped garment input after loading data
    if (tagInfo.length > 0) {
      const firstUnmapped = tagInfo.find((item) => !item.rfid);
      if (firstUnmapped && inputRefs.current[firstUnmapped.id]) {
        inputRefs.current[firstUnmapped.id].focus();
      }
    }
  }, [tagInfo]);

  const removeTagText = (garmentId) => {
    // Reset RFID input for that garment
    setRfidInputs((prev) => ({ ...prev, [garmentId]: "" }));
  };

  const handleRemoveMapping = (garmentId) => {
    // Find the garment and clear its RFID tag
    const updatedList = tagInfo.map((item) =>
      item.id === garmentId ? { ...item, rfid: null } : item
    );
    setTagInfo(updatedList);

    // Reset RFID input for that garment
    setRfidInputs((prev) => ({ ...prev, [garmentId]: "" }));

    successMessage("RFID tag removed. You can re-scan now.");

    // Focus back on this garment's input
    setTimeout(() => {
      if (inputRefs.current[garmentId]) {
        inputRefs.current[garmentId].focus();
      }
    }, 200);
  };

  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);

  const handleConfirmAndContinue = () => {
    // Use the selectedQrCodeItems array for further processing
    if (!isSubmitButtonPressed) {
      // Filter valid RFIDs (non-empty and length >= 24)
      const RFIDArray = Object.keys(rfidInputs)
        .filter((key) => rfidInputs[key] && rfidInputs[key].length >= 24)
        .map((key) => ({
          qrCodeId: parseInt(key, 10),
          rfId: rfidInputs[key],
        }));

      // Prepare data
      const data = { list: RFIDArray };

      if (data.list.length > 0) {
        // Enable submit button / proceed
        setIsSubmitButtonPressed(true);

        mapRFIDTag(data)
          .then((response) => {
            if (!response.data.error) {
              const Res = response.data;
              setModalVisible(true);
              setApiResStatus(Res.status);
              setApiResMessage(Res.message);
              if (Res.status) {
                const timer = setTimeout(() => {
                  navigate("/OrdersGarmentInfo", {
                    state: {
                      storeCustomerId: storeCustomerId,
                      bookingOrderId: bookingOrderId,
                    },
                  });
                  setIsSubmitButtonPressed(false);
                }, 1200);
                return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
              }
            }
          })
          .catch((err) => {
            console.error("Error:", err);
          });
      } else {
        errorMessage("Please Scan or Add RFID Tag");
      }
    }
  };

  const renderTagInfoItem = () => {
    return tagInfo?.map((item, index) => {
      const garmentName =
        item.garmentAlias !== "" ? item.garmentAlias : item.garment;

      return (
        <div key={item.id} className="border-bottom-1 mx-3 px-3">
          <div className="flex flex-column">
            <div className="flex justify-content-between align-items-center">
              <div className="col-3">
                <p className="text-xl font-medium">
                  {item.qrcode} - {garmentName.replace(/_/g, " ")}
                </p>
              </div>
              {/* RFID Input - hide if mapped */}
              {!item.rfid && (
                <div className="col-9 mx-4 mt-3 mb-2 flex justify-content-between align-items-center">
                  <IconField iconPosition="left" className="flex flex-1 mr-5">
                    <InputText
                      ref={(el) => (inputRefs.current[item.id] = el)} // assign ref
                      placeholder="Scan RFID Tag Here"
                      value={rfidInputs[item.id] || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        setRfidInputs((prev) => ({
                          ...prev,
                          [item.id]: value,
                        }));

                        // Auto move focus when RFID length = 24
                        if (value.length === 24) {
                          handleRFIDScan(item.id, e.target.value);
                        }
                      }}
                      // onKeyDown={(e) => {
                      //   if (e.key === "Enter") {
                      //     handleRFIDScan(item.id);
                      //   }
                      // }}
                      className="text-xl flex flex-1 py-1 px-5"
                      style={{ borderRadius: 30 }}
                    />
                  </IconField>
                  {rfidInputs[item.id] && (
                    <button
                      onClick={() => removeTagText(item.id)}
                      className="p-button p-button-danger p-button-sm mr-5"
                      style={{
                        backgroundColor: "#ff4d4f",
                        color: "#fff",
                        border: "none",
                        borderRadius: "6px",
                        padding: "4px 10px",
                        cursor: "pointer",
                      }}
                    >
                      X
                    </button>
                  )}
                </div>
              )}
              {/* Show mapped RFID */}
              {item.rfid && (
                <div className="flex col-9 justify-content-between align-items-center ml-5 mt-2">
                  <p className="text-green-600 font-semibold ml-5 mt-2">
                    ✅ Mapped Tag: {item.rfid}
                  </p>
                  <button
                    onClick={() => handleRemoveMapping(item.id)}
                    className="p-button p-button-danger p-button-sm mr-5"
                    style={{
                      backgroundColor: "#ff4d4f",
                      color: "#fff",
                      border: "none",
                      borderRadius: "6px",
                      padding: "4px 10px",
                      cursor: "pointer",
                    }}
                  >
                    Remove
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => {
                    userRole === "BY_STORE"
                      ? navigate("/OrdersGarmentInfo", {
                          state: {
                            bookingOrderId: bookingOrderId,
                            storeCustomerId: storeCustomerId,
                          },
                        })
                      : navigate(-1);
                  }}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Mapped RFID With Garment
              </p>
            </div>
          </div>
        </div>
      </div>
      <div style={{ backgroundColor: "#fff" }}>
        <div>
          {tagInfo.length > 0 ? (
            <div>{renderTagInfoItem()}</div>
          ) : (
            <p
              className="text-xl font-medium text-center my-4"
              style={{
                color: "#008EFF",
              }}
            >
              No Garment Present
            </p>
          )}
        </div>
        <SuccessModal
          setModalVisible={setModalVisible}
          modalVisible={modalVisible}
          status={apiResStatus === true ? "success" : false}
          text={apiResMessage}
        />
      </div>
      <div className="relative mt-8">
        {tagInfo.length > 0 && (
          <div
            className="flex flex-1 flex-row  py-2 fixed z-2 bottom-0 w-full"
            style={{ backgroundColor: "white" }}
          >
            <div className="flex-1 flex-row mx-4 mb-1 gap-2">
              <Button
                className="p-2 w-full text-2xl border-1 flex justify-content-center"
                style={{
                  color: "#fff",
                  backgroundColor: "#2B70D7",
                  borderRadius: 5,
                }}
                onClick={() => handleConfirmAndContinue()}
                disabled={isSubmitButtonPressed}
              >
                Submit
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GarmentRFIDList;
